import React, {useEffect} from "react";
import PropTypes from "prop-types";

const toggleItemInterface = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
}

const UiToggle = (props) => {

  const {toggleItems, className} = props;

  const activeIndex = toggleItems.findIndex((item) => item.isActive);

  return (
    <div className={"ui-toggle" + (className ? " " + className : "")} data-index={activeIndex}>
      {toggleItems.map(toggleItem => (
        <div className={"ui-toggle__item" + (toggleItem.isActive ? " ui-toggle__item--active" : "")}
             onClick={toggleItem.onClick}
             key={toggleItem.text}>
          {toggleItem.text}
        </div>
      ))}
    </div>
  )
}

UiToggle.propTypes = {
  toggleItems: PropTypes.arrayOf(PropTypes.shape(toggleItemInterface)).isRequired,
  className: PropTypes.string,
};

export default UiToggle
